
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13082',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13082",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9889",
  "foundations-components": "static-1.8360",
  "foundations-components-legacy": "static-1.1385",
  "foundations-theming": "static-1.4685",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8257",
  "hub-http-shared-msw-handlers": "static-1.10501",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11713",
  "I18n": "static-7.1656",
  "jasmine-runner": "static-1.6680",
  "marketplace-discovery-studio-lib": "static-1.524",
  "marketplace-storefront-base": "static-1.13145",
  "quartz": "static-1.7342",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16939",
  "reactive-variable-buffer-atom": "static-1.3087",
  "reporting-testing-lib": "static-1.10450",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12752",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7534",
  "ui-addon-i18n": "static-1.11378",
  "ui-addon-react-router-dom": "static-1.9765",
  "unified-auth": "static-1.771",
  "unified-auth-core-lib": "static-1.1053",
  "usage-tracker": "static-1.7589",
  "usage-tracker-core": "static-1.7439",
  "customer-data-property-utils": "static-1.8330",
  "hub-http": "static-1.6445",
  "integrations-lib": "static-1.16892",
  "marketplace-ui-common": "static-1.20531",
  "marketplace-ui-install": "static-1.517",
  "property-management-iframe": "static-1.13934",
  "quartz-config": "static-1.1120",
  "quartz-core": "static-1.6561",
  "quartz-routing": "static-1.772",
  "quick-fetch": "static-1.4080",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4894",
  "ts-schema": "static-1.4242",
  "ui-universal-auth": "static-1.9257",
  "UIComponents": "static-3.8659",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3563",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3619",
  "quartz-webpack": "static-1.3566",
  "bend-plugin-quartz-routing": "static-1.420",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4629",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5107",
  "foundations-theming-specialty": "static-1.2401",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9658",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.56",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5503",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2420",
  "ui-fonts": "static-1.975",
  "ui-images": "static-2.1224",
  "bend-plugin-foundations-theming": "static-1.3168",
  "foundations-theming-base": "static-1.3670",
  "stylex": "static-1.37",
  "HeadJS": "static-2.786",
  "hs-test-utils-bend-plugin": "static-1.3368",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4550",
  "ui-addon-video-player": "static-1.8938",
  "ai-components-ui-library": "static-1.9549",
  "ai-rendering-library": "static-1.10966",
  "chirp-fetch": "static-1.2119",
  "connections-embed-lib": "static-1.1412",
  "copilot-toolkit": "static-1.11714",
  "feedback-loader": "static-1.29710",
  "laboratory-lib": "static-3.7383",
  "marketplace-embed": "static-1.22782",
  "marketplace-ui-details": "static-1.10426",
  "marketplace-ui-reviews": "static-1.20486",
  "marketplace-ui-tracking": "static-1.14701",
  "sanitize-text": "static-1.8381",
  "usage-tracker-multi": "static-1.6003",
  "usage-tracker-session-replay": "static-1.5275",
  "wootric-nps": "static-1.7149",
  "quartz-head": "static-1.1007",
  "web-vitals": "static-1.10",
  "apollo-link-hub-http": "static-2.4889",
  "immer": "static-1.94",
  "immerable": "static-1.4383",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2637",
  "reporting-data": "static-1.68517",
  "cssUtils": "static-1.863",
  "flux-actions": "static-1.358",
  "HubStyle": "static-2.12020",
  "PatternValidationJS": "static-1.3128",
  "react-colorpicker": "static-2.10439",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.71",
  "ReduxMessenger": "static-2.10597",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7579",
  "icons": "static-2.673",
  "marketplace-ui-apps-core": "static-1.19063",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4742",
  "foundations-components-test-utils": "static-1.5843",
  "quartz-i18n": "static-1.1017",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.322",
  "ads-unified-auth-lib": "static-1.902",
  "google-sheets-integration-lib": "static-1.899",
  "microsoft-drive-integration-lib": "static-1.1045",
  "surveymonkey-integration-lib": "static-1.345",
  "slack-ui-library": "static-1.10628",
  "fsm": "static-1.3969",
  "customer-data-objects": "static-1.7917",
  "property-translator": "static-1.5626",
  "hs-locale-management": "static-1.244",
  "frontend-preferences-client": "static-1.8160",
  "hs-promise-utils": "static-1.5827",
  "hubspot-apollo-client": "static-1.5109",
  "integrations-error-boundary-lib": "static-1.14307",
  "integrations-tracking-lib": "static-1.5840",
  "native-integrations-shared-strings": "static-1.8009",
  "sanitize": "static-1.4708",
  "superstore": "static-1.4988",
  "ui-shepherd-react": "static-3.10494",
  "ai-settings-ui-library": "static-1.8233",
  "hub-http-janus": "static-1.864",
  "hubspotter-http": "static-1.4812",
  "immutable-less": "static-1.4883",
  "marketplace-ui-client-types": "static-1.17938",
  "nav-meta": "static-1.30330",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18303",
  "ui-product-approvals-common": "static-1.855",
  "ai-studio-lib": "static-1.12311",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.385",
  "ui-addon-iframeable": "static-1.9308",
  "ui-addon-integrations-directory-panel": "static-2.8257",
  "ui-product-approvals": "static-1.28960",
  "ui-tool-access": "static-1.10385",
  "inbound-db-properties-service-client": "static-1.4005",
  "property-management-common": "static-1.6222",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.561",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1017",
  "quartz-test": "static-1.1017",
  "quartz-tracking": "static-1.721",
  "trellis-components": "static-1.2439",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.304",
  "bender-build-tools": "static-1.3358",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22563",
  "ContentUtils": "static-1.69025",
  "customer-data-objects-ui-components": "static-1.13263",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2729",
  "breeze-engine-core": "static-1.813",
  "breeze-onboarding-components": "static-1.583",
  "customer-data-filters-ui": "static-1.40702",
  "customer-data-reference-ui-components": "static-1.13410",
  "embedded-academy-lib": "static-1.15298",
  "ExportDialog": "static-6.10612",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41879",
  "reporting-snowflake": "static-1.57135",
  "reporting-ui-components": "static-2.65788",
  "reporting-visualizations": "static-1.60593",
  "trellis-theming": "static-1.1187",
  "ui-addon-teams": "static-1.21838",
  "upgrade-components-lib": "static-1.437",
  "magpie-lib": "static-1.5711",
  "navigation-components": "static-1.18693",
  "breeze-engine-lib": "static-1.1535",
  "magpie-types": "static-1.5171",
  "simple-logging-lib": "static-1.3281",
  "fail-safe": "static-1.183",
  "app-governance-lib": "static-1.2261",
  "developer-experience-shared-components": "static-1.10730",
  "purchase-motions-components": "static-1.6265",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9945",
  "usage-tracker-anonymous": "static-1.6006",
  "usage-tracker-public": "static-1.7400",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3933",
  "reference-resolvers": "static-1.8414",
  "ui-extensibility-client-types": "static-1.4152",
  "hubspot-apollo-cache": "static-1.568",
  "universal-page-editor-lib": "static-1.3242",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.73",
  "simple-data-table": "static-1.3411",
  "atom": "static-1.5308",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10872",
  "ui-addon-draggable": "static-3.4988",
  "content-assistance-lib": "static-1.8110",
  "content-media-capture": "static-1.5252",
  "customer-data-ui-utilities": "static-1.10058",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24317",
  "growth-payments-core": "static-1.26042",
  "knowledge-content-types": "static-1.8614",
  "payment-link-components": "static-1.24050",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20213",
  "ui-addon-emoji-picker": "static-1.10118",
  "ui-business-units-lib": "static-1.9313",
  "video-components-external": "static-1.12019",
  "video-data-lib": "static-1.35677",
  "navigation-messaging": "static-1.8020",
  "collaboration-sidebar": "static-1.58574",
  "react-dnd-compat": "static-1.4847",
  "batch-promise": "static-1.1776",
  "crm-component-utils": "static-1.39705",
  "crm-properties-common-lib": "static-1.6121",
  "customer-data-properties": "static-1.52384",
  "external-options-client-types": "static-1.4289",
  "framework-data-schema-resolvers": "static-1.7125",
  "property-value-citations": "static-1.2998",
  "reference-resolvers-lite": "static-1.8331",
  "hubspotter-http-shared-msw-handlers": "static-1.10499",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5046",
  "content-icons-ui": "static-1.2298",
  "breeze-artifacts-sdk": "static-1.132",
  "onboarding-journeys-lib": "static-1.750",
  "pulse": "static-1.856",
  "conversations-skeleton-state": "static-1.7481",
  "crm-message-bus": "static-1.43601",
  "customer-data-filters-ui-msw-helpers": "static-1.23137",
  "events-data-lib": "static-1.475",
  "FormUrlGenerator": "static-2.4957",
  "framework-builder-read-service-client": "static-1.4169",
  "framework-data-schema-quick-fetch": "static-1.7030",
  "multi-account-reference-resolvers": "static-1.1230",
  "onboarding-tours": "static-1.17016",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14340",
  "academy-common-lib": "static-1.14758",
  "dashboard-lib": "static-1.82529",
  "getting-started-shared-tasks": "static-1.19081",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8936",
  "ui-asset-management-lib": "static-1.11321",
  "user-context": "static-1.5344",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68195",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.952",
  "nest": "static-1.469",
  "breeze-engine-chat-components": "static-1.513",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.134",
  "framework-listing-lib": "static-2.29343",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31283",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4486",
  "onboarding-scopes": "static-1.6690",
  "purchase-motions-api": "static-1.6268",
  "signup-constants": "static-1.19460",
  "signup-ui-url-generator": "static-2.8290",
  "onboarding-tours-client": "static-1.5230",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7834",
  "subscription-experience-data-types": "static-1.15178",
  "crm-record-cards-service-types": "static-1.3743",
  "location-customization-utils-lib": "static-1.9960",
  "redux-thunk": "static-2.75",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29185",
  "content-media-composition-data-lib": "static-1.13056",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4656",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.577",
  "ui-addon-opt": "static-4.8594",
  "commerce-tours-lib": "static-1.6512",
  "growth-onboarding-reliability": "static-1.5312",
  "sales-checkout-service-client": "static-1.3768",
  "data-token-picker": "static-1.16794",
  "FileManagerLib": "static-1.39957",
  "content-media-compositions": "static-2.17063",
  "media-bridge-lib": "static-1.19314",
  "chatspot-widget-iframe": "static-1.22554",
  "collaboration-sidebar-common": "static-1.3371",
  "marketing-platform-lib": "static-1.7100",
  "card-properties-lib": "static-1.44873",
  "commerce-subscription-lib": "static-1.37647",
  "crm-actions": "static-1.6583",
  "crm-cards-sdk": "static-1.44337",
  "customer-data-properties-shared-msw-handlers": "static-1.9828",
  "customer-data-tracking": "static-1.7114",
  "hs-resources": "static-1.420",
  "calling-global-api": "static-1.65314",
  "calling-internal-common": "static-1.31548",
  "calling-lifecycle-internal": "static-1.66696",
  "calling-lifecycle-messages": "static-1.58990",
  "commerce-products-lib": "static-1.10374",
  "conditional-properties-service-client": "static-1.3961",
  "crm-links": "static-1.6552",
  "crm-index-visualization-core": "static-1.4453",
  "crm-pipelines-api-client-types": "static-1.4298",
  "formula-editor": "static-1.14651",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4374",
  "meetings-icalendar-utils-lib": "static-1.867",
  "multi-currency-client-types": "static-1.3855",
  "object-builder-ui-client": "static-1.49487",
  "pipeline-validation-client-types": "static-1.4130",
  "smart-property-lib": "static-1.8143",
  "tiered-pricing": "static-1.1834",
  "topics-actions-lib": "static-1.391",
  "ui-addon-form-validation": "static-1.11218",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.244",
  "bend-plugin-pulse": "static-1.359",
  "event-emitter": "static-1.1184",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1500",
  "growth-data-modal": "static-1.5795",
  "growth-onboarding-confetti": "static-1.3293",
  "growth-onboarding-next-action-utils": "static-1.2565",
  "onboarding-tours-utils": "static-1.1082",
  "ui-shepherd-tracker": "static-1.7875",
  "academy-service-client": "static-1.3922",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39816",
  "SafeStorage": "static-1.4635",
  "video-embed": "static-1.36511",
  "redux-actions": "static-3.67",
  "EmailSignatureEditor": "static-1.24886",
  "viral-links-lib": "static-1.7305",
  "nested-table": "static-1.466",
  "timezone-utils": "static-2.5478",
  "getting-started-shared-tasks-store": "static-1.18199",
  "campaign-roi-lib": "static-1.9953",
  "ui-addon-calendars": "static-2.5558",
  "customer-data-views-management": "static-1.25909",
  "framework-data-table": "static-2.12420",
  "nudge-client-utils": "static-1.3043",
  "nudge-custom-ui-functions": "static-1.1396",
  "switchboard-lib": "static-1.446",
  "access-check-ui-lib": "static-1.1453",
  "app-users-service-client": "static-1.5850",
  "app-users-service-types": "static-1.5258",
  "mini-checkout-client": "static-1.27400",
  "onboarding-utils": "static-1.5594",
  "permissions-shared-i18n-strings-fe": "static-1.2115",
  "ui-coaching-tips-shared-config": "static-1.29170",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7079",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3717",
  "edison-service-client-types": "static-1.621",
  "growth-onboarding-feedback-components": "static-1.6814",
  "audio-components": "static-1.6252",
  "FileManagerImages": "static-1.37468",
  "video-components": "static-1.14021",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92705",
  "customer-data-sidebar": "static-2.46617",
  "enrichment-properties-lib": "static-1.17723",
  "ui-addon-draggable-compat": "static-2.4493",
  "universal-record-utils-lib": "static-1.1679",
  "commerce-billing-lib": "static-1.19926",
  "commerce-shared-components-lib": "static-1.19104",
  "commerce-tools-ui-lib": "static-1.10932",
  "crm-fe-perf": "static-1.23131",
  "calling-error-reporting": "static-1.31555",
  "shared-worker-versioning": "static-1.11271",
  "calling-usage-tracker": "static-1.6771",
  "voice-sms-access-library": "static-1.1846",
  "commerce-permissions": "static-1.1008",
  "products-iframe-lib": "static-1.8469",
  "products-ui-components-shared-msw-handlers": "static-1.10883",
  "crm-index-associations-lib": "static-1.6673",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10584",
  "sales-views-client-types": "static-1.4489",
  "bark-lib": "static-1.16737",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.550",
  "policy-lib": "static-1.7025",
  "react-tinymce": "static-1.55844",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10647",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54970",
  "tinymce-plugins": "static-1.58084",
  "tinymce-themes": "static-1.56940",
  "onboarding-data-sync-lib": "static-1.2366",
  "growth-onboarding-next-action-components": "static-1.2593",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4765",
  "outpost": "static-1.4394",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22061",
  "sales-email-signature-service-client": "static-1.4077",
  "ts-utils-lib": "static-1.407",
  "crm-export-dialog": "static-1.6517",
  "crm-view-components": "static-1.965",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7563",
  "nudge-custom-function-registry": "static-1.2800",
  "nudge-renderer-utils": "static-1.3119",
  "whisper-core-api": "static-1.7194",
  "InboxConnectUtils": "static-4.15429",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46718",
  "hub-http-rxjs": "static-1.829",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4223",
  "company-details-components": "static-1.6433",
  "react-performance-metrics-lib": "static-1.786",
  "pricing-pages-ui-components": "static-1.15391",
  "quote-checkout-service-types": "static-1.3687",
  "social-insights-client-types": "static-1.22680",
  "crm_universal": "static-1.22401",
  "customer-data-email": "static-1.18428",
  "card-payment-highlight-lib": "static-1.37840",
  "card-subscription-highlight-lib": "static-1.40070",
  "commerce-contract-lib": "static-1.13109",
  "invoices-highlight-card-lib": "static-1.55484",
  "orders-highlight-card-lib": "static-1.22061",
  "products-highlight-card-lib": "static-1.18657",
  "quotes-highlight-card-lib": "static-1.72710",
  "crm-source-interpretation-lib": "static-1.5565",
  "crm-object-search-query-utilities": "static-1.10086",
  "utility-belt": "static-1.2764",
  "payments-enrollment-embed-lib": "static-1.23682",
  "stripe-embedded-components": "static-1.7902",
  "customer-data-rte": "static-1.33533",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6169",
  "payments-post-enroll-local-storage-lib": "static-1.5339",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38800",
  "calling-orchestration-schema": "static-1.36623",
  "react-reducer-toolkit": "static-1.16239",
  "hub-http-contrib": "static-1.3271",
  "interframe": "static-3.4987",
  "tinymce-data": "static-1.41055",
  "ui-addon-sales-email": "static-1.5445",
  "layout-dnd-components": "static-1.12868",
  "layout-dnd-utils": "static-1.11843",
  "ui-brand-identity-lib": "static-1.16166",
  "NamespacedHubStyle": "static-2.9213",
  "meetings-connect-utils-lib": "static-1.7839",
  "access-control-lib": "static-1.10669",
  "EmailComponents": "static-1.55421",
  "EmailData": "static-1.54099",
  "redux-less": "static-2.9712",
  "company-details-service-types": "static-1.4171",
  "segments-query-core": "static-1.1655",
  "pricing-pages-api": "static-1.15256",
  "sequences-lib": "static-1.8440",
  "ui-gdpr-components": "static-1.10586",
  "products-ui-components": "static-1.40892",
  "accounting-integrations-ui-components": "static-1.7444",
  "invoices-ui-lib": "static-1.55500",
  "commerce-products-api": "static-1.2621",
  "invoices-iframe-lib": "static-1.57558",
  "quotes-modal-lib": "static-1.103388",
  "quotes-ui-lib": "static-1.81431",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28797",
  "ContentData": "static-1.69100",
  "layout-data-lib": "static-1.10168",
  "ContentComponents": "static-2.71981",
  "marketing-contacts-lib": "static-1.10829",
  "marketing-email-service-types": "static-1.2060",
  "messaging-editing-lib": "static-1.46997",
  "messaging-usage-based-billing-components-lib": "static-1.1859",
  "automation-ui-source-apps": "static-1.19535",
  "automation-ui-types": "static-1.20453",
  "messaging-types-lib": "static-1.46734",
  "onboarding-settings-client": "static-1.4741",
  "sequences-client-types-lib": "static-1.8297",
  "commerce-tax-lib": "static-1.773",
  "price-books-api": "static-1.1593",
  "price-books-components": "static-1.1651",
  "property-description-translator": "static-1.4070",
  "ramp-editor": "static-1.768",
  "commerce-analytics-service-client": "static-1.3756",
  "totals-ui-components": "static-1.24180",
  "SalesContentIndexUI": "static-3.9548",
  "advanced-menus-core": "static-1.15492",
  "advanced-menus-lib": "static-1.12377",
  "ui-memberships-settings-lib": "static-1.34679",
  "automation-ui-ubb": "static-1.6369",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7566",
  "data-token-views": "static-1.16775",
  "forms-utils-lib": "static-1.12996",
  "payments-embed-points-lib": "static-1.13486",
  "simple-menus-core": "static-1.15491",
  "simple-menus-lib": "static-1.17008",
  "videoconference-integration-components": "static-1.7155",
  "marketing-contacts-client": "static-1.7739",
  "mc-hard-limits-client-types": "static-1.133",
  "automation-applications-service-types": "static-1.3637",
  "automation-platform-service-types": "static-1.2648",
  "ContentEditorUI": "static-2.77761",
  "short-messages-app-service-client": "static-1.4152",
  "web-interactives-components": "static-1.14151",
  "web-interactives-data": "static-1.14152",
  "messaging-shared-utils-lib": "static-1.1308",
  "messaging-user-info-utils-lib": "static-1.1478",
  "email-portal-health-service-types": "static-1.1210",
  "line-items-api": "static-1.1018",
  "commerce-totals-service-types": "static-1.3980",
  "FireAlarmUi": "static-1.4670",
  "sales-templates-service-types-lib": "static-1.4331",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22389",
  "automation-ui-usage-tracking": "static-1.21852",
  "data-studio-ubb": "static-1.3384",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27542",
  "content-management-data-lib": "static-1.5847",
  "copilot-plugins": "static-1.11686",
  "cta-picker": "static-1.36966",
  "customer-agent-discovery-components-lib": "static-1.3754",
  "editor-components": "static-1.13556",
  "editor-iframe-lib": "static-1.8714",
  "error-messaging-js": "static-1.5426",
  "FormsCommonComponents": "static-1.86453",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10881",
  "SharedLegalStrings": "static-1.1978",
  "smart-content-core": "static-1.43050",
  "smart-content-lib": "static-1.43703",
  "social-composer-lib": "static-1.60029",
  "structured-content-lib": "static-1.25794",
  "theme-previewer-lib": "static-1.53822",
  "tinymce-copilot": "static-1.17038",
  "xray-recommendation-lib": "static-1.8190",
  "automation-ui-routing": "static-1.21810",
  "sql-reporting-client-types": "static-1.5836",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42676",
  "campaigns-utils-lib": "static-1.3430",
  "reporting-enablement": "static-1.23681",
  "forms-ai-lib": "static-1.4667",
  "codemirror-dlb": "static-1.59320",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6671",
  "report-customization-components": "static-1.13767",
  "data-quality-ui-library": "static-1.13643",
  "reporting-filters": "static-1.883",
  "reporting-insights-lib": "static-1.2429"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13082",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9889",
  "foundations-components": "/foundations-components/static-1.8360",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1385",
  "foundations-theming": "/foundations-theming/static-1.4685",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8257",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10501",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11713",
  "I18n": "/I18n/static-7.1656",
  "jasmine-runner": "/jasmine-runner/static-1.6680",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.524",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13145",
  "quartz": "/quartz/static-1.7342",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16939",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3087",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10450",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12752",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7534",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11378",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9765",
  "unified-auth": "/unified-auth/static-1.771",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1053",
  "usage-tracker": "/usage-tracker/static-1.7589",
  "usage-tracker-core": "/usage-tracker-core/static-1.7439",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8330",
  "hub-http": "/hub-http/static-1.6445",
  "integrations-lib": "/integrations-lib/static-1.16892",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20531",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.517",
  "property-management-iframe": "/property-management-iframe/static-1.13934",
  "quartz-config": "/quartz-config/static-1.1120",
  "quartz-core": "/quartz-core/static-1.6561",
  "quartz-routing": "/quartz-routing/static-1.772",
  "quick-fetch": "/quick-fetch/static-1.4080",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4894",
  "ts-schema": "/ts-schema/static-1.4242",
  "ui-universal-auth": "/ui-universal-auth/static-1.9257",
  "UIComponents": "/UIComponents/static-3.8659",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3563",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3619",
  "quartz-webpack": "/quartz-webpack/static-1.3566",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.420",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4629",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5107",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2401",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9658",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.56",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5503",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2420",
  "ui-fonts": "/ui-fonts/static-1.975",
  "ui-images": "/ui-images/static-2.1224",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3168",
  "foundations-theming-base": "/foundations-theming-base/static-1.3670",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.786",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3368",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4550",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8938",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9549",
  "ai-rendering-library": "/ai-rendering-library/static-1.10966",
  "chirp-fetch": "/chirp-fetch/static-1.2119",
  "connections-embed-lib": "/connections-embed-lib/static-1.1412",
  "copilot-toolkit": "/copilot-toolkit/static-1.11714",
  "feedback-loader": "/feedback-loader/static-1.29710",
  "laboratory-lib": "/laboratory-lib/static-3.7383",
  "marketplace-embed": "/marketplace-embed/static-1.22782",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10426",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20486",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14701",
  "sanitize-text": "/sanitize-text/static-1.8381",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6003",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5275",
  "wootric-nps": "/wootric-nps/static-1.7149",
  "quartz-head": "/quartz-head/static-1.1007",
  "web-vitals": "/web-vitals/static-1.10",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4889",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4383",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2637",
  "reporting-data": "/reporting-data/static-1.68517",
  "cssUtils": "/cssUtils/static-1.863",
  "flux-actions": "/flux-actions/static-1.358",
  "HubStyle": "/HubStyle/static-2.12020",
  "PatternValidationJS": "/PatternValidationJS/static-1.3128",
  "react-colorpicker": "/react-colorpicker/static-2.10439",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.71",
  "ReduxMessenger": "/ReduxMessenger/static-2.10597",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7579",
  "icons": "/icons/static-2.673",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19063",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4742",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5843",
  "quartz-i18n": "/quartz-i18n/static-1.1017",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.322",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.902",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.899",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1045",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.345",
  "slack-ui-library": "/slack-ui-library/static-1.10628",
  "fsm": "/fsm/static-1.3969",
  "customer-data-objects": "/customer-data-objects/static-1.7917",
  "property-translator": "/property-translator/static-1.5626",
  "hs-locale-management": "/hs-locale-management/static-1.244",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8160",
  "hs-promise-utils": "/hs-promise-utils/static-1.5827",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5109",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14307",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5840",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8009",
  "sanitize": "/sanitize/static-1.4708",
  "superstore": "/superstore/static-1.4988",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10494",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8233",
  "hub-http-janus": "/hub-http-janus/static-1.864",
  "hubspotter-http": "/hubspotter-http/static-1.4812",
  "immutable-less": "/immutable-less/static-1.4883",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17938",
  "nav-meta": "/nav-meta/static-1.30330",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18303",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.855",
  "ai-studio-lib": "/ai-studio-lib/static-1.12311",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.385",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9308",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8257",
  "ui-product-approvals": "/ui-product-approvals/static-1.28960",
  "ui-tool-access": "/ui-tool-access/static-1.10385",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
  "property-management-common": "/property-management-common/static-1.6222",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.561",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1017",
  "quartz-test": "/quartz-test/static-1.1017",
  "quartz-tracking": "/quartz-tracking/static-1.721",
  "trellis-components": "/trellis-components/static-1.2439",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.304",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22563",
  "ContentUtils": "/ContentUtils/static-1.69025",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13263",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2729",
  "breeze-engine-core": "/breeze-engine-core/static-1.813",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.583",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40702",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13410",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15298",
  "ExportDialog": "/ExportDialog/static-6.10612",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41879",
  "reporting-snowflake": "/reporting-snowflake/static-1.57135",
  "reporting-ui-components": "/reporting-ui-components/static-2.65788",
  "reporting-visualizations": "/reporting-visualizations/static-1.60593",
  "trellis-theming": "/trellis-theming/static-1.1187",
  "ui-addon-teams": "/ui-addon-teams/static-1.21838",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.437",
  "magpie-lib": "/magpie-lib/static-1.5711",
  "navigation-components": "/navigation-components/static-1.18693",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1535",
  "magpie-types": "/magpie-types/static-1.5171",
  "simple-logging-lib": "/simple-logging-lib/static-1.3281",
  "fail-safe": "/fail-safe/static-1.183",
  "app-governance-lib": "/app-governance-lib/static-1.2261",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10730",
  "purchase-motions-components": "/purchase-motions-components/static-1.6265",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9945",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6006",
  "usage-tracker-public": "/usage-tracker-public/static-1.7400",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3933",
  "reference-resolvers": "/reference-resolvers/static-1.8414",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4152",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.568",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3242",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.73",
  "simple-data-table": "/simple-data-table/static-1.3411",
  "atom": "/atom/static-1.5308",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10872",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4988",
  "content-assistance-lib": "/content-assistance-lib/static-1.8110",
  "content-media-capture": "/content-media-capture/static-1.5252",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10058",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24317",
  "growth-payments-core": "/growth-payments-core/static-1.26042",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "payment-link-components": "/payment-link-components/static-1.24050",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20213",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10118",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9313",
  "video-components-external": "/video-components-external/static-1.12019",
  "video-data-lib": "/video-data-lib/static-1.35677",
  "navigation-messaging": "/navigation-messaging/static-1.8020",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58574",
  "react-dnd-compat": "/react-dnd-compat/static-1.4847",
  "batch-promise": "/batch-promise/static-1.1776",
  "crm-component-utils": "/crm-component-utils/static-1.39705",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6121",
  "customer-data-properties": "/customer-data-properties/static-1.52384",
  "external-options-client-types": "/external-options-client-types/static-1.4289",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7125",
  "property-value-citations": "/property-value-citations/static-1.2998",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8331",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10499",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5046",
  "content-icons-ui": "/content-icons-ui/static-1.2298",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.132",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.750",
  "pulse": "/pulse/static-1.856",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7481",
  "crm-message-bus": "/crm-message-bus/static-1.43601",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23137",
  "events-data-lib": "/events-data-lib/static-1.475",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4957",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4169",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7030",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1230",
  "onboarding-tours": "/onboarding-tours/static-1.17016",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14340",
  "academy-common-lib": "/academy-common-lib/static-1.14758",
  "dashboard-lib": "/dashboard-lib/static-1.82529",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19081",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8936",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11321",
  "user-context": "/user-context/static-1.5344",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68195",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.952",
  "nest": "/nest/static-1.469",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.513",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.134",
  "framework-listing-lib": "/framework-listing-lib/static-2.29343",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31283",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4486",
  "onboarding-scopes": "/onboarding-scopes/static-1.6690",
  "purchase-motions-api": "/purchase-motions-api/static-1.6268",
  "signup-constants": "/signup-constants/static-1.19460",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8290",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5230",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7834",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15178",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3743",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9960",
  "redux-thunk": "/redux-thunk/static-2.75",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29185",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13056",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4656",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.577",
  "ui-addon-opt": "/ui-addon-opt/static-4.8594",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6512",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5312",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3768",
  "data-token-picker": "/data-token-picker/static-1.16794",
  "FileManagerLib": "/FileManagerLib/static-1.39957",
  "content-media-compositions": "/content-media-compositions/static-2.17063",
  "media-bridge-lib": "/media-bridge-lib/static-1.19314",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22554",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3371",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7100",
  "card-properties-lib": "/card-properties-lib/static-1.44873",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37647",
  "crm-actions": "/crm-actions/static-1.6583",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44337",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9828",
  "customer-data-tracking": "/customer-data-tracking/static-1.7114",
  "hs-resources": "/hs-resources/static-1.420",
  "calling-global-api": "/calling-global-api/static-1.65314",
  "calling-internal-common": "/calling-internal-common/static-1.31548",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66696",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58990",
  "commerce-products-lib": "/commerce-products-lib/static-1.10374",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3961",
  "crm-links": "/crm-links/static-1.6552",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4453",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4298",
  "formula-editor": "/formula-editor/static-1.14651",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4374",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.867",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3855",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49487",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4130",
  "smart-property-lib": "/smart-property-lib/static-1.8143",
  "tiered-pricing": "/tiered-pricing/static-1.1834",
  "topics-actions-lib": "/topics-actions-lib/static-1.391",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11218",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.244",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.359",
  "event-emitter": "/event-emitter/static-1.1184",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1500",
  "growth-data-modal": "/growth-data-modal/static-1.5795",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3293",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2565",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1082",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7875",
  "academy-service-client": "/academy-service-client/static-1.3922",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39816",
  "SafeStorage": "/SafeStorage/static-1.4635",
  "video-embed": "/video-embed/static-1.36511",
  "redux-actions": "/redux-actions/static-3.67",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24886",
  "viral-links-lib": "/viral-links-lib/static-1.7305",
  "nested-table": "/nested-table/static-1.466",
  "timezone-utils": "/timezone-utils/static-2.5478",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18199",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9953",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5558",
  "customer-data-views-management": "/customer-data-views-management/static-1.25909",
  "framework-data-table": "/framework-data-table/static-2.12420",
  "nudge-client-utils": "/nudge-client-utils/static-1.3043",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1396",
  "switchboard-lib": "/switchboard-lib/static-1.446",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1453",
  "app-users-service-client": "/app-users-service-client/static-1.5850",
  "app-users-service-types": "/app-users-service-types/static-1.5258",
  "mini-checkout-client": "/mini-checkout-client/static-1.27400",
  "onboarding-utils": "/onboarding-utils/static-1.5594",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2115",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29170",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7079",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3717",
  "edison-service-client-types": "/edison-service-client-types/static-1.621",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6814",
  "audio-components": "/audio-components/static-1.6252",
  "FileManagerImages": "/FileManagerImages/static-1.37468",
  "video-components": "/video-components/static-1.14021",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92705",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46617",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17723",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4493",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1679",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19926",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19104",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10932",
  "crm-fe-perf": "/crm-fe-perf/static-1.23131",
  "calling-error-reporting": "/calling-error-reporting/static-1.31555",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11271",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6771",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1846",
  "commerce-permissions": "/commerce-permissions/static-1.1008",
  "products-iframe-lib": "/products-iframe-lib/static-1.8469",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10883",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6673",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10584",
  "sales-views-client-types": "/sales-views-client-types/static-1.4489",
  "bark-lib": "/bark-lib/static-1.16737",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.550",
  "policy-lib": "/policy-lib/static-1.7025",
  "react-tinymce": "/react-tinymce/static-1.55844",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10647",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54970",
  "tinymce-plugins": "/tinymce-plugins/static-1.58084",
  "tinymce-themes": "/tinymce-themes/static-1.56940",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2366",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2593",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4765",
  "outpost": "/outpost/static-1.4394",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22061",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4077",
  "ts-utils-lib": "/ts-utils-lib/static-1.407",
  "crm-export-dialog": "/crm-export-dialog/static-1.6517",
  "crm-view-components": "/crm-view-components/static-1.965",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7563",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2800",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3119",
  "whisper-core-api": "/whisper-core-api/static-1.7194",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15429",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46718",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.829",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4223",
  "company-details-components": "/company-details-components/static-1.6433",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.786",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15391",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3687",
  "social-insights-client-types": "/social-insights-client-types/static-1.22680",
  "crm_universal": "/crm_universal/static-1.22401",
  "customer-data-email": "/customer-data-email/static-1.18428",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37840",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40070",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13109",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55484",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22061",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18657",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72710",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5565",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10086",
  "utility-belt": "/utility-belt/static-1.2764",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23682",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7902",
  "customer-data-rte": "/customer-data-rte/static-1.33533",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6169",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5339",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38800",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36623",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16239",
  "hub-http-contrib": "/hub-http-contrib/static-1.3271",
  "interframe": "/interframe/static-3.4987",
  "tinymce-data": "/tinymce-data/static-1.41055",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5445",
  "layout-dnd-components": "/layout-dnd-components/static-1.12868",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11843",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16166",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9213",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7839",
  "access-control-lib": "/access-control-lib/static-1.10669",
  "EmailComponents": "/EmailComponents/static-1.55421",
  "EmailData": "/EmailData/static-1.54099",
  "redux-less": "/redux-less/static-2.9712",
  "company-details-service-types": "/company-details-service-types/static-1.4171",
  "segments-query-core": "/segments-query-core/static-1.1655",
  "pricing-pages-api": "/pricing-pages-api/static-1.15256",
  "sequences-lib": "/sequences-lib/static-1.8440",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10586",
  "products-ui-components": "/products-ui-components/static-1.40892",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7444",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55500",
  "commerce-products-api": "/commerce-products-api/static-1.2621",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57558",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103388",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81431",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28797",
  "ContentData": "/ContentData/static-1.69100",
  "layout-data-lib": "/layout-data-lib/static-1.10168",
  "ContentComponents": "/ContentComponents/static-2.71981",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10829",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46997",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1859",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19535",
  "automation-ui-types": "/automation-ui-types/static-1.20453",
  "messaging-types-lib": "/messaging-types-lib/static-1.46734",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4741",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8297",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.773",
  "price-books-api": "/price-books-api/static-1.1593",
  "price-books-components": "/price-books-components/static-1.1651",
  "property-description-translator": "/property-description-translator/static-1.4070",
  "ramp-editor": "/ramp-editor/static-1.768",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3756",
  "totals-ui-components": "/totals-ui-components/static-1.24180",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9548",
  "advanced-menus-core": "/advanced-menus-core/static-1.15492",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12377",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34679",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6369",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7566",
  "data-token-views": "/data-token-views/static-1.16775",
  "forms-utils-lib": "/forms-utils-lib/static-1.12996",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13486",
  "simple-menus-core": "/simple-menus-core/static-1.15491",
  "simple-menus-lib": "/simple-menus-lib/static-1.17008",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7155",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7739",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.133",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3637",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2648",
  "ContentEditorUI": "/ContentEditorUI/static-2.77761",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4152",
  "web-interactives-components": "/web-interactives-components/static-1.14151",
  "web-interactives-data": "/web-interactives-data/static-1.14152",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1308",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1478",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1210",
  "line-items-api": "/line-items-api/static-1.1018",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3980",
  "FireAlarmUi": "/FireAlarmUi/static-1.4670",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4331",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22389",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21852",
  "data-studio-ubb": "/data-studio-ubb/static-1.3384",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27542",
  "content-management-data-lib": "/content-management-data-lib/static-1.5847",
  "copilot-plugins": "/copilot-plugins/static-1.11686",
  "cta-picker": "/cta-picker/static-1.36966",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3754",
  "editor-components": "/editor-components/static-1.13556",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8714",
  "error-messaging-js": "/error-messaging-js/static-1.5426",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86453",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10881",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1978",
  "smart-content-core": "/smart-content-core/static-1.43050",
  "smart-content-lib": "/smart-content-lib/static-1.43703",
  "social-composer-lib": "/social-composer-lib/static-1.60029",
  "structured-content-lib": "/structured-content-lib/static-1.25794",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53822",
  "tinymce-copilot": "/tinymce-copilot/static-1.17038",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8190",
  "automation-ui-routing": "/automation-ui-routing/static-1.21810",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5836",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42676",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3430",
  "reporting-enablement": "/reporting-enablement/static-1.23681",
  "forms-ai-lib": "/forms-ai-lib/static-1.4667",
  "codemirror-dlb": "/codemirror-dlb/static-1.59320",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6671",
  "report-customization-components": "/report-customization-components/static-1.13767",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13643",
  "reporting-filters": "/reporting-filters/static-1.883",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2429"
}
};
